import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const shouldShowAdvisorPicker = (
	connectedAdvisors: AgentAssignedListItemResponseDTO[],
	advisorsPending: number,
) => connectedAdvisors.length > 1 || advisorsPending > 0;
